var searchTypingTimer;

$(document).on('input', '.search__input', function () {
    clearTimeout(searchTypingTimer);

    var $input = $(this);

    searchTypingTimer = setTimeout(function () {
        var searchValue = $input.val();
        var searchUrl = window.Shopify.routes.root + 'search';

        fetch(
            searchUrl +
            '?q=' + encodeURIComponent(searchValue) +
            '&type=product&section_id=main-search'
        )
            .then(function (res) {
                return res.text();
            })
            .then(function (data) {
                var searchHtml = $(data);

                var products = $(
                    '.hidden-result .search__show-products',
                    searchHtml
                );

                var button = $(
                    '.hidden-result .search__btn-wrap',
                    searchHtml
                );

                $('.search__main .search__show-products')
                    .replaceWith(products);

                $('.search__main .search__btn-wrap')
                    .replaceWith(button);
            })
            .catch(function (error) {
                console.error('Search failed:', error);
            });

    }, 1000);
});